import React from 'react';

function BinanceWalletTutorial() {
  return (
    <div className="tutorial-section" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#495057', marginBottom: '15px' }}>📱 如何使用币安web3钱包</h3>
      
      <div className="tutorial-steps">
        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤1: 创建web3钱包</h4>
        
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/create-web3.png"
              alt="创建币安web3钱包"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 币安web3钱包创建界面图片
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default BinanceWalletTutorial; 